export const environment = {
    production: false,
    hmr: false,
    //webApiBaseUri: 'https://localhost:44382/api',
    webApiBaseUri:'https://apicentral.efiling.dev.alncorp.com/api',
    centralAppBaseUri: 'https://apps.dev.alncorp.com',
    centralApiBaseUri: 'https://api.apps.dev.alncorp.com',
    EnablePDFConversionOptimization: 'true',
    stsUrl: 'https://identity.dev.alncorp.com/',
    clientId: 'eFiling',
    redirectRoute: '/appgateway/home',
    //clientUrl: 'http://localhost:4200',
    clientUrl: 'https://central.efiling.dev.alncorp.com',
    silentRenewRoute: 'silent-renew.html',
    logConsoleDebugActive: true,
    awsBucket: "https://s3-us-west-2.amazonaws.com/efilingstaging/Stage/Concierge/dev/",
    eFilingTylerAppBaseUri: 'https://ty.efiling.dev.alncorp.com',
    eFilingOCAppBaseUri: 'https://oc.efiling.dev.alncorp.com',
    //eFilingOCAppBaseUri: 'https://localhost:44383/api',
    eDocketsURL: 'https://edockets.dev.alncorp.com',
    smartDocketsURL: 'http://dev.smartdockets.com',
    formWorkFlowURL: 'https://qa.formsworkflow.com',
    docketAlertsURL: 'http://dev.docketalerts.com',
    eDocketsAPI: 'https://cmread.api.dev.alncorp.com/api',
    iManageURL:'https://imanage.dev.alncorp.com/Home/Index?action=download',
    netDocURL: 'https://vault.netvoyage.com/neWeb2/goId.aspx',
    eDocketsFileUploadURL:'https://fileupload.api.dev.alncorp.com/api',

};

